module.exports = __webpack_public_path__ + "static/media/16UNODC38.b37fd6de.jpg";